/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ClassroomdisciplineIdUsersStudents202,
  PutApiV1ClassroomdisciplineIdUsersStudents400,
  PutApiV1ClassroomdisciplineIdUsersStudents401,
  PutApiV1ClassroomdisciplineIdUsersStudents404,
  PutApiV1ClassroomdisciplineIdUsersStudentsMutationRequest,
  PutApiV1ClassroomdisciplineIdUsersStudentsMutationResponse,
  PutApiV1ClassroomdisciplineIdUsersStudentsPathParams,
} from "../../types/classPlanningPeopleController/PutApiV1ClassroomdisciplineIdUsersStudents.ts";
import { classroomUserBulkSaveViewModelSchema } from "../classroomUserBulkSaveViewModelSchema.ts";

export const putApiV1ClassroomdisciplineIdUsersStudentsPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1ClassroomdisciplineIdUsersStudentsPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ClassroomdisciplineIdUsersStudents202Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdUsersStudents202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ClassroomdisciplineIdUsersStudents400Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdUsersStudents400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ClassroomdisciplineIdUsersStudents401Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdUsersStudents401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ClassroomdisciplineIdUsersStudents404Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineIdUsersStudents404>;

export const putApiV1ClassroomdisciplineIdUsersStudentsMutationRequestSchema =
  z.lazy(
    () => classroomUserBulkSaveViewModelSchema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdUsersStudentsMutationRequest>;

export const putApiV1ClassroomdisciplineIdUsersStudentsMutationResponseSchema =
  z.lazy(
    () => putApiV1ClassroomdisciplineIdUsersStudents202Schema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineIdUsersStudentsMutationResponse>;
